import { render, staticRenderFns } from "./Step4ConfirmConfig.vue?vue&type=template&id=fb071ab0&scoped=true"
import script from "./Step4ConfirmConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./Step4ConfirmConfig.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Step4ConfirmConfig.vue?vue&type=style&index=0&id=fb071ab0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb071ab0",
  null
  
)

export default component.exports